import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class RefrigeratedAirDryerNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.RefrigeratedAirDryer,
    });
  }
}
